import { useQueryClient } from "react-query";

export const useQueryData = (key, defaultValue = {}) => {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(key);
  if (!data) {
    return defaultValue;
  }
  return data;
};
